<template>
  <div v-if="isRelevant" class="-ian">
    <i v-if="prevDisabled" class="wticon wticon-angle-left -disabled" />
    <i v-else class="wticon wticon-angle-left" @click="prev" title="Previous" />
    <span
      v-if="showSerialCounterNumbers"
      class="-text"
      v-text="serialCounterNumbers"
    />
    <span v-else class="-spring" />
    <i v-if="nextDisabled" class="wticon wticon-angle-right -disabled" />
    <i v-else class="wticon wticon-angle-right" @click="next" title="Next" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { debounce } from 'lodash';
import app from 'app';

/** (GW)
 * Asset Editor's general done button
 */
export default {
  name: 'ian-controls',
  computed: {
    ...mapState('assetEditor', ['ian', 'openedFrom']),

    isRelevant() {
      return this.ian.total > 1;
    },

    prevDisabled() {
      return !this.isRelevant || (!this.ian.loop && this.ian.current <= 0);
    },

    nextDisabled() {
      return (
        !this.isRelevant ||
        (!this.ian.loop && this.ian.current >= this.ian.total - 1)
      );
    },

    serialCounterNumbers() {
      return `${this.ian.current + 1} of ${this.ian.total}`;
    },

    showSerialCounterNumbers() {
      return this.openedFrom !== 'asset-gallery';
    },
  },

  beforeDestroy() {
    app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.IAN);
  },

  mounted() {
    app.keyboardAccessibility.add(app.KEYBOARD_LAYER.IAN, [
      { on: 'keydown', key: $.ui.keyCode.LEFT, run: this.prev },
      { on: 'keydown', key: $.ui.keyCode.RIGHT, run: this.next },
    ]);
  },

  methods: {
    ...mapActions('assetEditor', ['NAVIGATE_TO_ASSET']),

    prev: debounce(
      function (e) {
        e.preventDefault();
        if (!this.prevDisabled) {
          let prevIndex = this.ian.current - 1;
          if (prevIndex === -1 && this.ian.loop) {
            prevIndex = this.ian.total - 1;
          }
          const asset = this.ian.getAssets()[prevIndex];
          this.NAVIGATE_TO_ASSET({ asset });
        }
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),

    next: debounce(
      function (e) {
        e.preventDefault();
        if (!this.nextDisabled) {
          let nextIndex = this.ian.current + 1;
          if (nextIndex === this.ian.total) {
            nextIndex = 0;
          }
          const asset = this.ian.getAssets()[nextIndex];
          this.NAVIGATE_TO_ASSET({ asset });
        }
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),
  },
};
</script>

<style lang="scss" scoped>
.-ian {
  display: flex;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin: 0 16px 0 16px;

  .wticon {
    font-size: 16px;
    cursor: pointer;

    &:not(.-disabled):hover {
      color: black;
      transform: scale(1.1, 1.1);
    }
    &.-disabled {
      color: $color-disabled;
      cursor: default;
    }
  }

  .-text {
    padding: 0 26px;
  }

  .-spring {
    width: 22px;
  }
}
</style>
